import { TRIP_TYPE_ONE_WAY } from "../../../common/constants";
import { getServiceChargeInternational } from "../../../utils/serviceChargePrice";

export const getAirArabiaServiceCharge = (
  passengerCount,
  cabinPrice,
  company,
  corporate,
  discount,
  data = {}
) => {
  if (!company) return 0;

  const PaxBasePrice = cabinPrice.paxTypeWiseBasePrices;
  const cabinType = cabinPrice.cabinClass;

  const totalPassengers = passengerCount.ADT + passengerCount.CHD;

  let adultTotal = 0;
  let childTotal = 0;

  PaxBasePrice.forEach((item) => {
    if (item.paxType === "ADT") {
      adultTotal = item.price;
    }
    if (item.paxType === "CHD") {
      childTotal = item.price;
    }
  });

  // if (data?.passengerTypeState === "Non-Document-Holder") {
  //   adultTotal = +(adultTotal * corporate?.exchangeRate).toFixed(2);
  //   childTotal =
  //     childTotal > 0 ? +(childTotal * corporate?.exchangeRate).toFixed(2) : 0;
  // }

  let basePrice = 0;
  if (discount?.companyIds?.includes(company?._id)) {
    basePrice =
      discount?.serviceCharge * (passengerCount.ADT + passengerCount.CHD);
  } else {
    if (+data?.labors > 0 && company?.isLabor) {
      basePrice = company.serviceChargeLabor * +data.labors;
    } else if (data?.tripType === TRIP_TYPE_ONE_WAY && company?.isOneWay) {
      basePrice = company.serviceChargeOneWay * totalPassengers;
    } else {
      const adultCharge =
        getServiceChargeInternational(
          adultTotal,
          company?.serviceChargeInternational
        ) * (passengerCount.ADT || +data?.labors);

      const childCharge =
        childTotal > 0
          ? getServiceChargeInternational(
              childTotal,
              company?.serviceChargeInternational
            ) * passengerCount.CHD
          : 0;

      basePrice = adultCharge + childCharge;
    }
  }

  const isEconomyOrAny = cabinType === "Y" || cabinType === "Any";
  const isUSD = data?.currencyStates === "USD";

  // if (isEconomyOrAny) {
  return isUSD ? basePrice : basePrice * corporate?.exchangeRate;
  // }
};
